import { useDeleteAccountMutation } from '@src/services/profile/profileApiSlice';
import { logout } from '@src/store/user/userSlice';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

interface DeleteAccountProps {
  onClose: () => void;
}

export function DeleteAccount({ onClose }: Readonly<DeleteAccountProps>) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [deleteAccount, { isLoading }] = useDeleteAccountMutation();

  const handleDeleteAccount = () => {
    deleteAccount().then(() => {
      dispatch(logout(undefined));
    });
  };
  return (
    <div className='space-y-4'>
      <div className='!mt-6 text-R-16 space-y-4 text-wl-on-background bg-wl-background py-6 px-4 rounded-2xl'>
        <p>Do you want to delete account? This process cannot be undone.</p>
        <p>
          By clicking "delete" your account is going to be
          <b> permanently removed</b> and
          <b> all your eSIMs will be deactivated</b>. That means: Logging in
          with this email address again will create a new account that is in no
          way associated with current account.
        </p>
      </div>
      <div className='flex justify-between gap-4 !mt-6'>
        <Button onClick={onClose} className='btn-secondary w-1/2'>
          {t('buttons.cancel')}
        </Button>
        <Button
          loading={isLoading}
          className='w-1/2 btn-danger'
          onClick={handleDeleteAccount}
        >
          {t('buttons.deleteMyAccount')}
        </Button>
      </div>
    </div>
  );
}
